import { APP_INITIALIZER, Provider, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CheckChangedAuthUserAndReloadService } from './check-changed-auth-user-and-reload.service';

function initializeAuthUserChangeListener(
  platformId: Object,
  service: CheckChangedAuthUserAndReloadService
): () => void {
  return () => {
    if (isPlatformBrowser(platformId)) {
      service.initialize();
    }
  };
}

export function provideAuthUserChangeListener(): Provider[] {
  return [
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: initializeAuthUserChangeListener,
      deps: [PLATFORM_ID, CheckChangedAuthUserAndReloadService],
    },
  ];
}
